/**
 * Country ISO Code to Flag Emoji Mapping
 * Maps ISO 3166-1 alpha-2 codes to flag emojis
 */

export const countryFlags: Record<string, string> = {
  'US': '🇺🇸', 'GB': '🇬🇧', 'JP': '🇯🇵', 'FR': '🇫🇷', 'DE': '🇩🇪',
  'CA': '🇨🇦', 'AU': '🇦🇺', 'SG': '🇸🇬', 'IT': '🇮🇹', 'ES': '🇪🇸',
  'NL': '🇳🇱', 'BE': '🇧🇪', 'CH': '🇨🇭', 'AT': '🇦🇹', 'SE': '🇸🇪',
  'NO': '🇳🇴', 'DK': '🇩🇰', 'FI': '🇫🇮', 'PL': '🇵🇱', 'PT': '🇵🇹',
  'GR': '🇬🇷', 'IE': '🇮🇪', 'CN': '🇨🇳', 'IN': '🇮🇳', 'KR': '🇰🇷',
  'TH': '🇹🇭', 'MY': '🇲🇾', 'ID': '🇮🇩', 'PH': '🇵🇭', 'VN': '🇻🇳',
  'TW': '🇹🇼', 'HK': '🇭🇰', 'AE': '🇦🇪', 'SA': '🇸🇦', 'IL': '🇮🇱',
  'QA': '🇶🇦', 'KW': '🇰🇼', 'BH': '🇧🇭', 'OM': '🇴🇲', 'TR': '🇹🇷',
  'MX': '🇲🇽', 'BR': '🇧🇷', 'AR': '🇦🇷', 'CL': '🇨🇱', 'CO': '🇨🇴',
  'PE': '🇵🇪', 'ZA': '🇿🇦', 'EG': '🇪🇬', 'MA': '🇲🇦',
  'NG': '🇳🇬', 'NZ': '🇳🇿', 'AD': '🇦🇩', 'AI': '🇦🇮', 'AG': '🇦🇬',
  'AM': '🇦🇲', 'AW': '🇦🇼', 'AZ': '🇦🇿', 'BS': '🇧🇸', 'BD': '🇧🇩',
  'BB': '🇧🇧', 'BY': '🇧🇾', 'BJ': '🇧🇯', 'BM': '🇧🇲', 'BO': '🇧🇴',
  'BQ': '🇧🇶', 'BA': '🇧🇦', 'BW': '🇧🇼', 'BN': '🇧🇳', 'BG': '🇧🇬',
  'BF': '🇧🇫', 'BI': '🇧🇮', 'CV': '🇨🇻', 'KH': '🇰🇭', 'CM': '🇨🇲',
  'KY': '🇰🇾', 'CF': '🇨🇫', 'TD': '🇹🇩', 'CX': '🇨🇽', 'CC': '🇨🇨',
  'KM': '🇰🇲', 'CG': '🇨🇬', 'CD': '🇨🇩', 'CK': '🇨🇰', 'CR': '🇨🇷',
  'CI': '🇨🇮', 'HR': '🇭🇷', 'CU': '🇨🇺', 'CW': '🇨🇼', 'CY': '🇨🇾',
  'CZ': '🇨🇿', 'DJ': '🇩🇯', 'DM': '🇩🇲', 'DO': '🇩🇴', 'EC': '🇪🇨',
  'SV': '🇸🇻', 'GQ': '🇬🇶', 'ER': '🇪🇷', 'EE': '🇪🇪', 'ET': '🇪🇹',
  'FK': '🇫🇰', 'FO': '🇫🇴', 'FJ': '🇫🇯', 'GF': '🇬🇫', 'PF': '🇵🇫',
  'GA': '🇬🇦', 'GM': '🇬🇲', 'GE': '🇬🇪', 'GH': '🇬🇭', 'GI': '🇬🇮',
  'GL': '🇬🇱', 'GD': '🇬🇩', 'GP': '🇬🇵', 'GU': '🇬🇺', 'GT': '🇬🇹',
  'GG': '🇬🇬', 'GN': '🇬🇳', 'GW': '🇬🇼', 'GY': '🇬🇾', 'HT': '🇭🇹',
  'HN': '🇭🇳', 'HU': '🇭🇺', 'IS': '🇮🇸', 'IQ': '🇮🇶', 'IR': '🇮🇷',
  'IM': '🇮🇲', 'JM': '🇯🇲', 'JE': '🇯🇪', 'JO': '🇯🇴', 'KZ': '🇰🇿',
  'KE': '🇰🇪', 'KI': '🇰🇮', 'KP': '🇰🇵', 'XK': '🇽🇰', 'KG': '🇰🇬',
  'LA': '🇱🇦', 'LV': '🇱🇻', 'LB': '🇱🇧', 'LS': '🇱🇸', 'LR': '🇱🇷',
  'LY': '🇱🇾', 'LI': '🇱🇮', 'LT': '🇱🇹', 'LU': '🇱🇺', 'MO': '🇲🇴',
  'MK': '🇲🇰', 'MG': '🇲🇬', 'MW': '🇲🇼', 'MV': '🇲🇻', 'ML': '🇲🇱',
  'MT': '🇲🇹', 'MH': '🇲🇭', 'MQ': '🇲🇶', 'MR': '🇲🇷', 'MU': '🇲🇺',
  'YT': '🇾🇹', 'FM': '🇫🇲', 'MD': '🇲🇩', 'MC': '🇲🇨',
  'MN': '🇲🇳', 'ME': '🇲🇪', 'MS': '🇲🇸', 'MZ': '🇲🇿', 'MM': '🇲🇲',
  'NA': '🇳🇦', 'NR': '🇳🇷', 'NP': '🇳🇵', 'NC': '🇳🇨', 'NI': '🇳🇮',
  'NE': '🇳🇪', 'NU': '🇳🇺', 'NF': '🇳🇫', 'MP': '🇲🇵', 'PS': '🇵🇸',
  'PA': '🇵🇦', 'PG': '🇵🇬', 'PY': '🇵🇾', 'PN': '🇵🇳', 'PR': '🇵🇷',
  'RE': '🇷🇪', 'RO': '🇷🇴', 'RU': '🇷🇺', 'RW': '🇷🇼', 'BL': '🇧🇱',
  'SH': '🇸🇭', 'KN': '🇰🇳', 'LC': '🇱🇨', 'MF': '🇲🇫', 'PM': '🇵🇲',
  'VC': '🇻🇨', 'WS': '🇼🇸', 'SM': '🇸🇲', 'ST': '🇸🇹', 'SN': '🇸🇳',
  'RS': '🇷🇸', 'SC': '🇸🇨', 'SL': '🇸🇱', 'SK': '🇸🇰', 'SI': '🇸🇮',
  'SB': '🇸🇧', 'SO': '🇸🇴', 'GS': '🇬🇸', 'SS': '🇸🇸', 'LK': '🇱🇰',
  'SD': '🇸🇩', 'SR': '🇸🇷', 'SJ': '🇸🇯', 'SZ': '🇸🇿', 'SY': '🇸🇾',
  'TJ': '🇹🇯', 'TZ': '🇹🇿', 'TL': '🇹🇱', 'TG': '🇹🇬', 'TK': '🇹🇰',
  'TO': '🇹🇴', 'TT': '🇹🇹', 'TN': '🇹🇳', 'TM': '🇹🇲', 'TC': '🇹🇨',
  'TV': '🇹🇻', 'UG': '🇺🇬', 'UA': '🇺🇦', 'UY': '🇺🇾', 'UZ': '🇺🇿',
  'VU': '🇻🇺', 'VA': '🇻🇦', 'VE': '🇻🇪', 'VG': '🇻🇬', 'VI': '🇻🇮',
  'WF': '🇼🇫', 'EH': '🇪🇭', 'YE': '🇾🇪', 'ZM': '🇿🇲', 'ZW': '🇿🇼',
  'AX': '🇦🇽', 'AF': '🇦🇫', 'AL': '🇦🇱', 'AS': '🇦🇸', 'AO': '🇦🇴', 'AQ': '🇦🇶',
}

/**
 * Get flag emoji from ISO code
 */
export const getCountryFlag = (isoCode: string | null | undefined): string => {
  if (!isoCode) return '🌍'
  const upperIso = isoCode.toUpperCase()
  return countryFlags[upperIso] || '🌍'
}

